var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.893,14.978l-1.714,1.714c-.506.506-1.295.584-1.899.201-1.023-.649-1.972-1.411-2.852-2.291-.91-.91-1.692-1.869-2.355-2.902-.386-.602-.31-1.39.195-1.896l1.714-1.714-.658-5.469h-4.279c-.822,0-1.461.706-1.404,1.525.372,5.298,2.014,8.99,5.133,12.109,3.083,3.083,7.003,4.724,12.042,5.12.828.065,1.545-.57,1.545-1.401v-4.339s-5.469-.658-5.469-.658Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e6a03bc81098ae3a7f6a7ef6bde148a0.svg";
export { ForwardRef as ReactComponent };